if (!customElements.get('modal-window')) {
  customElements.define(
    'modal-window',
    class ModalWindow extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('[data-modal-trigger]');
        this.target = this.querySelector('[data-modal-target]');
        this.close = this.querySelectorAll('[data-modal-close]');
        this.modalWindow = this.querySelector('[data-modal-window]');
        this.body = this.closest('body');

        this.trigger.addEventListener('click', this.openModal.bind(this));

        this.close.forEach((button) => {
          button.addEventListener('click', this.closeModal.bind(this));
        });

        window.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeModal();
          }

          window.addEventListener('resize', this.closeModal.bind(this));
        });
      }

      openModal() {
        this.target?.classList.remove('hidden');
        this.body.classList.add('modal-is-open');
      }

      closeModal() {
        this.target?.classList.add('hidden');
        this.body.classList.remove('modal-is-open');
      }
    }
  );
}
